import React, { useMemo } from "react";
import { consultaDeFeriado } from "./feriados";
import {
  agruparEventosPorCliente,
  dayKey,
  groupEventsByDay,
  isSameDay,
  startOfDayLocal,
} from "./calendarGrid";
import {
  DayCardPill,
  DayCardText,
  DayEventCard,
  DayEventsCol,
  DayHojeBadge,
  DayLayout,
  DayPanel,
  DayPanelMonth,
  DayPanelNumber,
  DayPanelSpacer,
  DayPanelWeekday,
  DayStatRow,
  DayStats,
  DiaGrupo,
  DiaGrupoNome,
  EmptyMessage,
  FeriadoChip,
} from "./styles";

const VOCAB_DIA = { subitem: ["ambiente", "ambientes"], subitemTitulo: "Ambientes", grupoTitulo: "Clientes" };

export default function DayView({
  cursor, events, onSelectEvent, emptyMessage, vocab = VOCAB_DIA, feriadoDe = consultaDeFeriado(),
}) {
  const nomeFeriado = feriadoDe(cursor);
  const today = useMemo(() => startOfDayLocal(new Date()), []);
  const eventsByDay = useMemo(() => groupEventsByDay(events), [events]);
  const list = eventsByDay.get(dayKey(cursor)) || [];
  const isToday = isSameDay(cursor, today);
  const weekday = cursor.toLocaleDateString("pt-BR", { weekday: "long" });
  const longLabel = cursor.toLocaleDateString("pt-BR", {
    month: "long",
    year: "numeric",
  });
  const grupos = agruparEventosPorCliente(list);
  const nClientes = new Set(list.map((e) => e.groupLabel).filter(Boolean)).size;

  return (
    <DayLayout>
      <DayPanel>
        <DayPanelWeekday>{weekday}</DayPanelWeekday>
        <DayPanelNumber $today={isToday}>{cursor.getDate()}</DayPanelNumber>
        <DayPanelMonth>{longLabel}</DayPanelMonth>
        {isToday && <DayHojeBadge>Hoje</DayHojeBadge>}
        {nomeFeriado && (
          <FeriadoChip title={`Feriado: ${nomeFeriado}`}>
            <span aria-hidden="true">📅</span> {nomeFeriado}
          </FeriadoChip>
        )}
        <DayPanelSpacer />
        <DayStats>
          <DayStatRow>
            <span>{vocab.subitemTitulo}</span>
            <strong>{list.length}</strong>
          </DayStatRow>
          <DayStatRow>
            <span>{vocab.grupoTitulo}</span>
            <strong>{nClientes}</strong>
          </DayStatRow>
        </DayStats>
      </DayPanel>

      <DayEventsCol>
        {list.length === 0 ? (
          <EmptyMessage>{emptyMessage}</EmptyMessage>
        ) : (
          grupos.map((grupo) => (
            <DiaGrupo key={grupo.chave}>
              {grupo.label != null && (
                <DiaGrupoNome>
                  {grupo.label}
                  <span className="cont">
                    {grupo.eventos.length} {vocab.subitem[grupo.eventos.length === 1 ? 0 : 1]}
                  </span>
                </DiaGrupoNome>
              )}
              {grupo.eventos.map((eventItem) => {
                const statusLabel = eventItem.payload?.status;
                return (
                  <DayEventCard
                    type="button"
                    key={eventItem.id}
                    $tone={eventItem.tone}
                    $previsao={Boolean(eventItem.previsao)}
                    onClick={() => onSelectEvent?.(eventItem)}
                  >
                    <DayCardText>
                      <strong>{eventItem.title}</strong>
                      {eventItem.subtitle && <span>{eventItem.subtitle}</span>}
                    </DayCardText>
                    {statusLabel && (
                      <DayCardPill $tone={eventItem.tone}>{statusLabel}</DayCardPill>
                    )}
                  </DayEventCard>
                );
              })}
            </DiaGrupo>
          ))
        )}
      </DayEventsCol>
    </DayLayout>
  );
}
